import React from "react";
import { InputProjectInformationDialogInitialState, PageNewState } from ".";

export const InputProjectInformationDialogContext = React.createContext({
  pageState: InputProjectInformationDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
